<template>
  <div>
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label">
      <b-field
        :label="label"
        :type="{ 'is-danger': errors.length > 0 }"
        :message="errors[0]"
      >
        <input v-show="false" v-model="image" />
      </b-field>
      <p v-if="!image">No image uploaded.</p>
      <img v-if="image" :src="image" style="max-width: 200px" />
      <br />
      <b-button v-if="image" size="is-small" @click="removeImage()"
        >Remove</b-button
      >
      <br />
    </ValidationProvider>
    <b-upload
      v-model="imageFile"
      accept="image/*"
      drag-drop
      :loading="showUploadLoading"
      @input="uploadImage"
    >
      <section class="section">
        <div class="content has-text-centered">
          <p>
            <b-icon icon="upload" size="is-large"> </b-icon>
          </p>
          <p>Drop your file here or click to upload</p>
        </div>
      </section>
    </b-upload>
    <b-progress
      v-if="showUploadLoading"
      type="is-info"
      :value="showUploadProgress"
    ></b-progress>
  </div>
</template>

<script>
import UploadApi from "@/api/upload";
import EventBus from "@/eventbus";

export default {
  name: "UploadImage",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    rules: {
      type: String,
      default: "",
    },
    folder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showUploadLoading: false,
      imageFile: null,
      showUploadProgress: 0,
      image: null,
    };
  },
  watch: {
    value(value) {
      this.image = value;
    },
  },
  mounted() {
    if (this.value) {
      this.image = this.value;
    } else {
      this.$emit("input", null);
    }
  },
  methods: {
    removeImage() {
      this.image = null;
      this.$emit("input", null);
    },
    uploadImage(file) {
      this.showUploadLoading = true;
      UploadApi.getPresignedLink({
        file: file.name,
        bucket: "capturefit",
        folder: this.folder,
      })
        .then((response) => {
          EventBus.$on(file.name, (progress) => {
            this.showUploadProgress = progress;
          });
          UploadApi.uploadToS3(response, file)
            .then(() => {
              this.image = response.final;
              this.$emit("input", this.image);
              this.showUpload = false;
              this.showUploadLoading = false;
              EventBus.$off(file.name);
            })
            .catch((err) => {
              console.log(err);
              this.$buefy.toast.open({
                message: `Error uploading ${this.label} (2)`,
                position: "is-top",
                type: "is-danger",
              });
              this.showUploadLoading = false;
            });
        })
        .catch((err) => {
          console.log(err);
          this.$buefy.toast.open({
            message: `Error uploading ${this.label} (1)`,
            position: "is-top",
            type: "is-danger",
          });
          this.showUploadLoading = false;
        });
    },
  },
};
</script>
